// UTF-8 checker: áéíóú

import axios from 'axios';
import { parseString } from 'xml2js';
import _ from 'lodash';

import {
	SHOW_FEEDBACK,
	HIDE_FEEDBACK,
	SET_ITEMS,
	SET_ITEMS_AAXML,
	SET_ITEMS_KEYS,
	GO_TO_PREVIOUS_ITEM,
	GO_TO_NEXT_ITEM,
	GO_TO_ITEM,
	RECOVER_SAVED_STATE,
	SHOW_RESULTS,
	RESTART_EXERCISE,
	SET_INTERACTION,
	SET_VERSION,
	SET_TEST_MODE,
	SET_TEST_SENT,
	START_RECORDING,
	STOP_RECORDING,
	SET_EX_CONTAINER,
	SET_AUTO_NUM,
	SET_RANDOM_ITEMS_ORDER,
	SET_RANDOM_ITEMS,
	MARK_ITEM_WITH_AUDIO,
	SET_EXERCISE_READY,
	SET_ITEMS_TO_SHOW,
	SET_BASE_PATH,
	SET_ITEM_MARKED_TEXT,
	SET_CORRECT_ANSWER,
	ANSWER_QUESTION,
	SET_AUDIO_PREFIX,
	SET_AUDIO_ENABLED,
	SET_PHONEME
} from './types';

const API_URL = window.NL_CONFIG.api.url;

let apiRequestConfig = {
	withCredentials: true
};

// development
if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
	const auth = require('../config/auth.js').default; // eslint-disable-line global-require
	apiRequestConfig.auth = auth;
} else { // production
	apiRequestConfig = {
		headers: {
			'X-Session-Cookie-Name': window.discovia && window.discovia.directory
		},
	};
}

export const recoverSavedState = (state) => ({ type: RECOVER_SAVED_STATE, payload: state });
export const answerQuestion = () => ({ type: ANSWER_QUESTION });
export const showResults = () => ({ type: SHOW_RESULTS });
export const restartExercise = () => ({ type: RESTART_EXERCISE });
export const setInteraction = (interaction) => ({ type: SET_INTERACTION, payload: interaction });
export const setVersion = (version) => ({ type: SET_VERSION, payload: version });
export const setAutoNum = (autoNum) => ({ type: SET_AUTO_NUM, payload: autoNum });
export const setTestMode = (testMode) => ({ type: SET_TEST_MODE, payload: testMode });
export const setExContainer = (exContainer) => ({ type: SET_EX_CONTAINER, payload: exContainer });
export const goToPreviousItem = () => ({ type: GO_TO_PREVIOUS_ITEM });
export const goToNextItem = () => ({ type: GO_TO_NEXT_ITEM });
export const goToItem = (index) => ({ type: GO_TO_ITEM, payload: index });
export const setItemsToShow = (itemsToShow) => ({ type: SET_ITEMS_TO_SHOW, payload: itemsToShow });
export const setRandomItems = (randomItems) => ({ type: SET_RANDOM_ITEMS, payload: randomItems });
export const setBasePath = (basePath) => ({ type: SET_BASE_PATH, payload: basePath });
export const setItemMarkedText = (markedText) => ({ type: SET_ITEM_MARKED_TEXT, payload: markedText });
export const setAudioPrefix = (audioPrefix) => ({ type: SET_AUDIO_PREFIX, payload: audioPrefix });
export const setAudioEnabled = (enabled) => ({ type: SET_AUDIO_ENABLED, payload: enabled });
export const setPhoneme = (phoneme) => ({ type: SET_PHONEME, payload: phoneme });
export const showFeedback = (type, loading, messageId, fromItem) => async (dispatch, getState) => {
	dispatch({
		type: SHOW_FEEDBACK,
		payload: {
			index: fromItem === undefined ? getState().exercise.currentItem : fromItem,
			type,
			loading,
			messageId
		}
	});
};

export const showFeedbackBasedOnAnswer = (fromItem, correctAnswer) => async (dispatch, getState) => {
	const { loader: { testMode, testSent, interaction }, exercise: { correctAnswers, currentItem, items } } = getState();

	if (testMode && !testSent) {
		dispatch(showFeedback('recorded', null, null, fromItem));
	} else if (correctAnswer) {
		dispatch(showFeedback('correct', null, null, fromItem));
	} else {
		dispatch(showFeedback('incorrect', null, null, fromItem));
	}

	correctAnswers[currentItem] = correctAnswer;
	const allAnswered = correctAnswers.filter((c) => (c === true || c === false)).length === items.length;
	const numberCorrect = correctAnswers.filter((c) => c).length;
	// console.log('setScore(', numberCorrect, items.length, ')');

	// console.log(correctAnswers, 'items:', items.length, 'allAnswered:', allAnswered, 'numberCorrect:', numberCorrect, 'totalAnswers:', correctAnswers.length);
	// Only set score if all questions have been answered
	//if (interaction && allAnswered) interaction.setScore(numberCorrect, items.length);
	if (interaction) interaction.setScore(numberCorrect, items.length);
};

export const setCorrectAnswer = (correctAnswer) => async (dispatch, getState) => {
	const { exercise } = getState();
	dispatch(answerQuestion());
	dispatch(showFeedbackBasedOnAnswer(exercise.currentItem, correctAnswer));
	dispatch({ type: SET_CORRECT_ANSWER, payload: correctAnswer });
};

export const setItems = (items) => async (dispatch, getState) => {
	items.forEach((e, i) => e.itemIndex = i); // necesario para el save state (usado en updateInteraction)
	dispatch({ type: SET_ITEMS, payload: items });
};

export const setTestSent = () => async (dispatch, getState) => {
	const { exercise: { items, correctAnswers }, loader: { interaction } } = getState();
	dispatch({ type: SET_TEST_SENT });
	items.forEach((item, i) => dispatch(showFeedbackBasedOnAnswer(i, correctAnswers[i])));

	const allAnswered = correctAnswers.filter((c) => (c === true || c === false)).length === items.length;
	const numberCorrect = correctAnswers.filter((c) => c).length;
	console.log(interaction);
	//if (interaction && allAnswered) interaction.setScore(numberCorrect, items.length);
	if (interaction) interaction.setScore(numberCorrect, items.length);
};

export const hideFeedback = () => async (dispatch, getState) => dispatch({ type: HIDE_FEEDBACK, payload: { index: getState().exercise.currentItem } });

export const analyzeAudio = (blob) => async (dispatch, getState) => {
	try {
		dispatch(showFeedback('analysis', true));

		const { interaction } = getState().loader;
		const { exercise: { itemsAAXML, currentItem, phoneme, items }, loader: { itemsKeys } } = getState();
		const data = { aaxml: itemsAAXML[currentItem], key: itemsKeys[currentItem] };
		const apiUrl = `${API_URL}/audioanalysis/${(window.NL_CONFIG && window.NL_CONFIG.isSample) ? 'sample-url' : 'url'}`;
		const { data: { remoteURL, s3SignedURL } } = await axios.post(apiUrl, data, apiRequestConfig);

		const aaData = new FormData();
		aaData.append('audio', blob);
		aaData.audio = blob;

		const aaRes = await axios({
			method: 'post',
			url: remoteURL,
			data: aaData,
			config: { headers: { 'Content-Type': 'multipart/form-data' } }
		});

		if (!(window.userSession && window.userSession.user && window.userSession.user.readonly) && interaction && !window.NL_CONFIG.isSample && !window.concurrentUser) {
			await axios({
				method: 'put',
				url: s3SignedURL,
				data: blob,
				config: { headers: { 'Content-Type': blob.type } }
			});

			dispatch({ type: MARK_ITEM_WITH_AUDIO, payload: currentItem });
		}

		dispatch(hideFeedback());

		if (window.NL_CONFIG.sound.enabled) {
			window.soundManager.play('result');
		}

		parseString(aaRes.data, (err, result) => {
			let audioQualityMsgId;
			let answerIsCorrect;
			let markedText = '';
			try {
				audioQualityMsgId = window.loader.exercises.common.audioanalysis.getAudioQualityMsgId(result.message.AAResult[0].audioQuality[0].$.status);
			} catch (e) {
				dispatch(showFeedback('quality', null, 256));
				return;
			}

			if (audioQualityMsgId) {
				dispatch(showFeedback('quality', null, audioQualityMsgId));
				return;
			}

			if (err) alert(err.message);
			if (result.message.AAResult[0].error) {
				const errors = result.message.AAResult[0].error.join('\n - ');
				alert(`DESIGN-TIME ERROR\n\nThe following errors were returned by the analysis API:\n - ${errors}`);
			}

			const targetText = result.message.AAResult[0].analysis[0].readingSummary[0].targetText[0];
			const targetTokens = targetText.split(/(a\.m\.|p\.m\.|[-a-z0-9']+)/gi);

			markedText = '';
			let lastType = '';
			answerIsCorrect = true;
			let phonemeCorrect = false;
			let tokenCount = 0;
			result.message.AAResult[0].analysis[0].alignmentDetails[0].alignEntry.forEach((entry, alignCount) => {
				let word;
				const phonemeWords = (items[currentItem].$ && items[currentItem].$.phonemeWords) ? items[currentItem].$.phonemeWords.split(',') : [];
				switch (entry.$.alignType) {
					case 'OK':
						word = entry.target[0]._;
						while (targetTokens[tokenCount] !== word && tokenCount < targetTokens.length) {
							markedText += targetTokens[tokenCount];
							tokenCount++;
						}
						tokenCount++;

						if (phoneme || phonemeWords.includes(word)) {
							// replace simple word with the highlighted phonemes
							try {
								let newWord = '';
								let charCount = 0;
								const graphemes = entry.wordSeg[0].pinpointInfo[0].grapheme;
								graphemes.forEach((grapheme, index) => {
									let status = '';
									let highlightGrapheme = phonemeWords.includes(word) || (phoneme.length === 0);
									let phones = '';
									const phonemesInThisGrapheme = grapheme.phoneme || [];
									// console.log(grapheme);
									// console.log(typeof phonemesInThisGrapheme, phonemesInThisGrapheme);
									phonemesInThisGrapheme.forEach((onePhoneme, index) => {
										if (phoneme && phoneme.includes(onePhoneme.$.name)) {
											highlightGrapheme = true;
											if (onePhoneme.$.status === 'soso' || onePhoneme.$.status === 'ok') phonemeCorrect = true;
										}
										if (onePhoneme.$.status === 'bad') status = 'bad';
										if (onePhoneme.$.status === 'soso' && status !== 'bad') status = 'soso';
										if (onePhoneme.$.status === 'ok' && status !== 'bad' && status !== 'soso') status = 'ok';
										if (index > 0) phones += ' ';
										phones += onePhoneme.$.name;
									});
									let graphemeString = word.substring(charCount, charCount + grapheme.$.str.length);
									if (highlightGrapheme) {
										graphemeString = `<span title="${phones}" data-${status}>${graphemeString}</span>`;
										if (status === 'bad') answerIsCorrect = false;
									}
									newWord += graphemeString;
									// newWord += e.$.str;
									charCount += grapheme.$.str.length;
								});
								word = newWord;
							} catch (e) {
								console.log(e);
							}
						} else {
							const atts = entry.wordSeg[0].word[0].$;
							let tooltipText;
							switch (atts.ppStatus) {
								case 'ok': tooltipText = 'Word pronounced well'; break;
								case 'soso': tooltipText = 'Word pronounced okay'; break;
								default: tooltipText = 'Word incorrectly pronounced'; break;
							}
							word = `<span title="${tooltipText}" data-${atts.ppStatus}>${word}</span>`;
							if (atts.ppStatus === 'bad') answerIsCorrect = false;
						}
						break;
					case 'SUB':
						word = entry.target[0]._;
						while (targetTokens[tokenCount] !== word && tokenCount < targetTokens.length) {
							markedText += targetTokens[tokenCount];
							tokenCount++;
						}
						tokenCount++;
						word = `<span data-bad title="Word not recognised">${entry.target[0]._}</span>`;
						answerIsCorrect = false;
						break;
					case 'DEL':
						word = entry.target[0]._;
						while (targetTokens[tokenCount] !== word && tokenCount < targetTokens.length) {
							markedText += targetTokens[tokenCount];
							tokenCount++;
						}
						tokenCount++;
						word = `<span data-bad title="Word not detected">${entry.target[0]._}</span>`;
						answerIsCorrect = false;
						break;
					case 'INS':
						// if (lastType === 'SUB') return;
						if (lastType === entry.$.alignType) return;
						word = ' <span data-unknown title="Unknown sound heard here"><i class="fas fa-question-circle"></i></span> ';
						// word = ' <span data-unknown title="Unknown sound heard here"><i class="fas fa-ellipsis-h"></i></span> ';
						answerIsCorrect = false;
						break;
					case 'pause':
						// markedText += ' ... ';
						return;
					default:
						alert(`Unknown entry type: ${entry.$.alignType}`);
				}
				markedText += word;
				lastType = entry.$.alignType;
			});
			// Add on the tokens at the end of the sentence.
			while (tokenCount < targetTokens.length) {
				markedText += targetTokens[tokenCount];
				tokenCount++;
			}

			// If we are looking for specific phoneme(s) and none were found
			// then mark as incorrect as wrong pronunciation was probably used
			if (phoneme && phoneme.length > 0 && !phonemeCorrect) {
				answerIsCorrect = false;
			}

			dispatch(setItemMarkedText(markedText));
			dispatch(setCorrectAnswer(answerIsCorrect));
		});
	} catch (e) {
		console.log(e);
		// alert(e.message);
		dispatch(showFeedback('errored', null, (e.response && e.response.status) ? e.response.status : null));
	}
};

export const processItems = () => async (dispatch, getState) => {
	const { interaction } = getState().loader;
	const { items, itemsToShow, randomItems, randomItemsOrder } = getState().exercise;

	let processedItems = items;

	processedItems.forEach(item => {
		if (item.answer) {
			item.answer[0]._ = item.answer[0]._.replace('’', "'");
		} else {
			item._ = item._.replace('’', "'");
		}
	});

	if (randomItems) {
		let currentRandomItemsOrder = [];
		const randomizedItems = [];

		if (randomItemsOrder) {
			currentRandomItemsOrder = randomItemsOrder;
		} else {
			currentRandomItemsOrder = window.Utils.shuffle(processedItems.map(item => item.itemIndex));
			dispatch({ type: SET_RANDOM_ITEMS_ORDER, payload: currentRandomItemsOrder });
		}

		for (let i = 0; i < processedItems.length; i++) {
			randomizedItems.push(_.find(processedItems, (item) => item.itemIndex === currentRandomItemsOrder[i]));
		}

		processedItems = randomizedItems;
	}

	if (itemsToShow) {
		processedItems = processedItems.slice(0, itemsToShow);
	}

	dispatch({ type: SET_ITEMS, payload: processedItems });

	const itemsAAXML = processedItems.map(item => `
		<AARequest>
			<analysis analysisType="ReadingFluency" pinpoint="TRUE">
				<text>${item.answer ? item.answer[0]._ : item._}</text>
			</analysis>
		</AARequest>`
	);

	dispatch({
		type: SET_ITEMS_AAXML,
		payload: itemsAAXML
	});

	if (interaction && !window.concurrentUser) {
		const itemsKeys = processedItems.map((item, i) => {
			const { unitId } = window.NL_CONFIG;
			const resourceId = window.API._currentScoId; // eslint-disable-line
			const interactionIndex = interaction.index;
			if (unitId !== undefined && resourceId !== undefined && interactionIndex !== undefined) {
				return `${unitId}/${resourceId}/${interactionIndex}/${i}`;
			}
			return undefined;
		});

		dispatch({
			type: SET_ITEMS_KEYS,
			payload: itemsKeys
		});
	}

	dispatch({ type: SET_EXERCISE_READY });
};

export const setInteractionInterface = (interactionInterface) => async (dispatch, getState) => {
	const interaction = window.nl_loader.getNextInteraction();

	if (interaction) {
		interaction.setExerciseInteractionInterface(interactionInterface);
		dispatch(setInteraction(interaction));
	}
};

export const startRecording = () => async (dispatch, getState) => {
	dispatch({ type: START_RECORDING });
	dispatch(showFeedback('recording'));
};

export const stopRecording = (data) => async (dispatch, getState) => {
	dispatch({ type: STOP_RECORDING });
	dispatch(hideFeedback());
	dispatch(analyzeAudio(data));
};
